import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../auth/AuthContext';
import { PATIENTS_PATH } from '../constants/routes';

/**
 * 管理者と医師のみ子ルートを表示する。
 */
const AdminRoute: React.FC = () => {
  const { staffProfile, staffProfileLoading, staffProfileError } = useAuth();

  if (staffProfileLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (staffProfileError || !staffProfile || (staffProfile.role !== '管理者' && staffProfile.role !== '医師')) {
    return <Navigate to={PATIENTS_PATH} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
